<template>
  <div class="registerview">

    <div class="columns">
      <div class="column is-third">
        <HelloWorld style="color:green; font-weight: bold" msg="APPKA"/>
        <!-- <img alt="Vue logo" src="../assets/logo.png"> -->
      </div>

      <div class="column is-third">
        <div style="height: 4em"></div>

        <HelloWorld msg="REGISTRÁCIA" />

        <Register/>

      </div>

      <div class="column is-third">
        <div class="buttons">
          <a class="button is-primary" @click="navigateTo('/login')">
            <strong>PRIHLÁSENIE</strong>
          </a>
        </div>
      </div>
    </div>



    <!-- <img alt="Vue logo" src="../assets/logo.png">
    <HelloWorld msg="Welcome to APPKA"/>
    <div class="buttons">
      <a class="button is-primary">
        <strong>REGISTROVAT</strong>
      </a>
      
    </div> -->

    <!-- <Register/> -->

  </div>
</template>

<script>
// @ is an alias to /src
// import Login from '@/components/auth/Login.vue'
import Register from '@/components/auth/Register.vue'
import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'registerview',
  components: {
    HelloWorld,
    Register
  },
  methods: {
    navigateTo (routepath) {
      // window.alert(this.msg)
      this.$router.push({path: routepath})
    }
  }
}
</script>
